import { Row, Col,Container } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Menu = ({ isOpen, toggleMenu }) => {
  return (
    <>
    {isOpen && (<div className="cart-backdrop" onClick={toggleMenu}></div>)}
    <div className={`menu-sidebar ${isOpen ? 'open' : ''}`}>
        <Row>
        <Link to="/10-گردنبند">
            <label>گردنبند</label>
        </Link>
        </Row>
        <Row>
        <Link to="/23-چوکر">
            <label>چوکر</label>
        </Link>
        </Row>
        <Row>
        <Link to="/17-دستبند">
            <label>دستبند</label>
        </Link>
        </Row>
        <Row>
        <Link to="/11-گوشواره">
            <label>گوشواره</label>
        </Link>
        </Row>
        <Row>
        <Link to="/15-انگشتر">
            <label>انگشتر</label>
        </Link>
        </Row>
        <Row>
        <Link to="/21-آویز">
            <label>آویز</label>
        </Link>
        </Row>
        <Row>
        <Link to="/14-پابند">
            <label>پابند</label>
        </Link>
        </Row>
        <Row>
        <Link to="/22-مردانه">
            <label>مردانه</label>
        </Link>
        </Row>
        <Row>
        <Link to="/115-کودک">
            <label>کودک</label>
        </Link>
        </Row>
        <Row>
        <Link to="/101-قفل">
            <label>قفل</label>
        </Link>
        </Row>
                
    </div>
    </>
  );
}
export default Menu;